// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eopoi-widget .related_pois_teaser__wrapper a{color:#000;text-decoration:none}.eopoi-widget .related_pois_teaser__wrapper .swiper{width:100%}.eopoi-widget .related_pois_teaser__wrapper .swiper-button-next,.eopoi-widget .related_pois_teaser__wrapper .swiper-button-prev{background-color:#fff;padding:5px;opacity:.7;border-radius:50px;position:absolute;top:69px}", ""]);
// Exports
module.exports = exports;
